import DateTimeLabel from "./DateTimeLabel";
import PriceLabel from "./PriceLabel";

const exportObjs = {
  DateTime: DateTimeLabel,
  Price: PriceLabel,
};

export default exportObjs;
